import React, { useLayoutEffect, useMemo } from "react";
import WebsiteHeader from "./header";
import WebsiteFooter from "./footer";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { addData } from "../../../redux/slices/globalDetails";
import { GlobalSettingsDetails } from "../services/website.services";
import { hideMainLoader, setTitle } from "../../../utils/commonfunction";
import ScrollToTop from "./scrollToTop"; // adjust path as needed

function WebsiteLayout() {  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  window.navigate_ = navigate;

  useMemo(() => {
    GlobalSettingsDetails().then(async (globalDetails) => {
      dispatch(addData(JSON.stringify(globalDetails?.data)));
      setTitle(globalDetails?.data?.title);
      setTimeout(() => {
        dispatch(setGlobalLoader(false));
      }, 100);
    });
  }, []);

  useLayoutEffect(()=>{
    Promise.all([
      import("../../../assets/website/css/style.css"),
      import("../../../assets/website/css/responsive.css"),
    ]).then(() => {
      setTimeout(() => {
        hideMainLoader();
      }, 100);
    });
    const body = document.querySelector('body, html');
    if(body) body.scrollTop = 0;
  },[]);

  return (
    <div>
      <ScrollToTop />
        <WebsiteHeader />
          <div className="inner-wraper">
            <Outlet />
          </div>
        <WebsiteFooter />
    </div>
  );
}

export default WebsiteLayout;
